import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">For now, consider the following
                                                    questions:
                                                </div>
                                                <ul className="greenbullet-list">
                                                    <li>Who are my role models?</li>
                                                    <li>Why are they important?</li>
                                                    <li>Who can I be a role model for?</li>
                                                    <li>How do I currently ‘stack up?’</li>
                                                    <li className="textbottompadding">What should I do?</li>
                                                </ul>

                                            </div>
                                            <div><p>Below we outline a model of the common attributes for being
                                                an effective role model against
                                                which you can assess yourself.</p></div>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">ROLE MODEL CORE FEATURES</span>
                                            </div>
                                            <div className="uiheading"><p>The core features of being an
                                                effective role model are outlined below:</p></div>
                                            <div className="innovativeimg biimage">
                                            </div>

                                            <div align="center">

                                                <img
                                                    src={require('@images/rolemodel.png')}
                                                    border="0" useMap="#Map" style={{width: '100%'}}/></div>
                                            <br/>

                                            <map name="Map" id="Map">
                                                <area shape="rect" style={{cursor: 'pointer'}}
                                                      coords="117,8,278,136"
                                                      onMouseOver="Tip(&quot;<div class=\&quot;subtitle1\&quot;>Success</div><p>When you think of people you admire, most of them have either achieved something you value, e.g. a lifestyle, money, status or have a capability like caring for colleagues or being considerate. People often gauge how effective a role model is by the level of success they have achieved. It is therefore important to understand what success means and what target to aim for. Whatever the end goal, it is important to consider the impact that this will have on others and every person who is, or aspires to be, a role model should consider whether ‘good’ is good enough.</p>&quot;, TITLE, this.innerHTML, PADDING, 9, WIDTH, 650, TITLEBGCOLOR, &quot;#FDB83B&quot;, BGCOLOR, &quot;#FEEFD4&quot;, BORDERCOLOR, &quot;#FDB83B&quot;,FONTFACE,&quot;EK_MUKTALIGHT,SAN-SERIF&quot;,FONTSIZE,&quot;15px&quot;);"
                                                      onMouseOut="UnTip();"/>

                                                <area shape="rect" style={{cursor: 'pointer'}}
                                                      coords="440,8,610,127"
                                                      onMouseOver="Tip(&quot;<div class=\&quot;subtitle1\&quot;>Integrity</div><p>This element is all about ensuring that you live out certain values. This may be aboutadhering to company values or behaving in line with certain personal values. Anexample of a common value that both organisations and individuals hold is hardwork. Putting in hard work leads to success. For a role model to be effective theyhave to be seen, or perceived, to be putting in the effort in order to reap therewards. This is likely to be critical for most role models in reputable organisations,although there are exceptions which may include aspects of persuasion, negotiatingthe best deal and being cunning (although these are not necessarily exclusive ofhaving integrity).</p>&quot;, TITLE, this.innerHTML, PADDING, 9, WIDTH, 650, TITLEBGCOLOR, &quot;#FDB83B&quot;, BGCOLOR, &quot;#FEEFD4&quot;, BORDERCOLOR, &quot;#FDB83B&quot;,FONTFACE,&quot;EK_MUKTALIGHT,SAN-SERIF&quot;,FONTSIZE,&quot;15px&quot;);"
                                                      onMouseOut="UnTip();"/>

                                                <area shape="rect" style={{cursor: 'pointer'}}
                                                      coords="50,243,262,320"
                                                      onMouseOver="Tip(&quot;<div class=\&quot;subtitle1\&quot;>Quality</div><p>People often admire things that are of a high level quality such as a top-of-the-rangecar or a piece of craftsmanship. This focus on quality is itself considered of highvalue. In the workplace, working to, and insisting on, high levels of quality tendsproduce outstanding results. For example, if you are leading a new project you maywant to ensure that people clearly understand what level of quality you expect. Youcould point to similar, previously undertaken tasks or projects in order to benchmarkthe quality levels you require. It is worth showing people how you personally willaim to reach these high standards. This enables others to see the standards that youexpect and how you will adhere to these quality levels. It is then up to you to liveout this plan and produce work of an extremely high quality.</p>&quot;, TITLE, this.innerHTML, PADDING, 9, WIDTH, 650, TITLEBGCOLOR, &quot;#FDB83B&quot;, BGCOLOR, &quot;#FEEFD4&quot;, BORDERCOLOR, &quot;#FDB83B&quot;,FONTFACE,&quot;EK_MUKTALIGHT,SAN-SERIF&quot;,FONTSIZE,&quot;15px&quot;);"
                                                      onMouseOut="UnTip();"/>


                                                <area shape="rect" style={{cursor: 'pointer'}}
                                                      coords="319,432,424,467"
                                                      onMouseOver="Tip(document.getElementById(&quot;pbehaviour&quot;).innerHTML, TITLE, this.innerHTML, PADDING, 9, WIDTH, 650, TITLEBGCOLOR, &quot;#FDB83B&quot;, BGCOLOR, &quot;#FEEFD4&quot;, BORDERCOLOR, &quot;#FDB83B&quot;,FONTFACE,&quot;EK_MUKTALIGHT,SAN-SERIF&quot;,FONTSIZE,&quot;15px&quot;);"
                                                      onMouseOut="UnTip();"/>
                                                <area shape="rect" style={{cursor: 'pointer'}}
                                                      coords="573,267,683,307"
                                                      onMouseOver="Tip(document.getElementById(&quot;visibility&quot;).innerHTML, TITLE, this.innerHTML, PADDING, 9, WIDTH, 650, TITLEBGCOLOR, &quot;#FDB83B&quot;, BGCOLOR, &quot;#FEEFD4&quot;, BORDERCOLOR, &quot;#FDB83B&quot;,FONTFACE,&quot;EK_MUKTALIGHT,SAN-SERIF&quot;,FONTSIZE,&quot;15px&quot;);"
                                                      onMouseOut="UnTip();"/>

                                            </map>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">CORE FEATURES BREAKDOWN</span>
                                            </div>
                                            <div className="border_subtitle">Success</div>
                                            <p>When you think of people you admire, most of them have either
                                                achieved something you value,
                                                e.g. a lifestyle, money, status, or have a capability such
                                                as caring for colleagues or being
                                                considerate. People often gauge how effective a role model
                                                is by the level of success they have
                                                achieved. It is therefore important to understand what
                                                success means and what target to aim for.
                                                Whatever the end goal, it is important to consider the
                                                impact that this will have on others. Every
                                                person who is, or aspires to be, a role model should
                                                consider whether ‘good’ is enough.</p>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                        <div style={{display: 'none'}} id="pbehaviour">
                                            <div style={{clear: 'both'}} className="subtitle1">Positive behaviour
                                            </div>

                                            <p>There are many different types of role models but all will
                                                display some form of
                                                positive behaviour. This can cover a range of different actions
                                                or activities but the
                                                important aspect is that the behaviours are linked with some
                                                form of success or
                                                value set - that is, the behaviour leads to a successful result
                                                or the approach itself
                                                sets a good example for others, regardless of the outcome.</p>

                                            <div className="motivatebg">

                                                <p>Take the scenario of negotiating a business deal, examples of
                                                    positive behaviours
                                                    in this situation could include:</p>
                                                <div className="orange_bulletarrow4">
                                                    <ul>

                                                        <li>Sticking to a game plan for negotiating a win-win
                                                            outcome.
                                                        </li>
                                                        <li>Being honest about what can and can't be
                                                            compromised.
                                                        </li>
                                                        <li>Facilitating meetings to involve all parties.</li>
                                                        <li>Communicating the progress and outcomes with all
                                                            stakeholders.
                                                        </li>
                                                    </ul>
                                                </div>

                                            </div>

                                            <div style={{display: 'none'}} id="visibility">
                                                <div style={{clear: 'both'}} className="subtitle1">Visibility</div>

                                                <p>Part of role modelling effectively is ensuring that people
                                                    can see what actions and
                                                    behaviour is being undertaken. Maintaining a visible profile
                                                    is important to ensure
                                                    that the approach can be seen by others in order for them to
                                                    learn from it. This is
                                                    not just about status for the sake of maintaining a certain
                                                    profile but can be used to
                                                    help others understand what good behaviour is, or how to
                                                    conduct themselves. In
                                                    this way people can better understand what success looks
                                                    like and how it can be
                                                    achieved.</p>


                                                <div className="motivatebg">

                                                    <p>The following pages outline two practical tools to help
                                                        you to be an effective role
                                                        model:</p>
                                                    <div className="orange_bulletarrow4">
                                                        <ul>

                                                            <li>Common Misconceptions.</li>
                                                            <li>Role Model Attributes Self Analysis.</li>
                                                        </ul>
                                                    </div>


                                                </div>


                                            </div>

                                        </div>


                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}